import { UsersReportRecord } from 'components/organisms/users-report/types';
import { ApiUsersReport } from './api-types';

export const asUsersReport = ({
  peopleReports,
}: ApiUsersReport): UsersReportRecord[] => {
  return peopleReports.map(
    ({
      commentsCount,
      projectsAssigned,
      task,
      timeEntryInfo,
      totalTaskCount,
      allocationInfo,
      timeOffInfo,
      ...rest
    }) => ({
      ...rest,
      commentsCount,
      projectsAssigned,
      taskInfo: {
        totalAssignedCount: totalTaskCount,
        newAssignedCount: task?.count,
        completedOnTimeCount: task?.completedOnTimeCount,
        completedOnTimeCountPercentage: task?.completedOnTimeCountPercentage,
        completedLateCount: task?.completedLateCount,
        completedLateCountPercentage: task?.completedLateCountPercentage,
        inProgressCount: task?.inProgressCount,
        inProgressCountPercentage: task?.inProgressCountPercentage,
        overdueCount: task?.overdueCount,
        overdueCountPercentage: task?.overdueCountPercentage,
        blockedCount: task?.blockedCount,
        blockedCountPercentage: task?.blockedCountPercentage,
        atRiskCount: task?.atRiskCount,
        atRiskCountPercentage: task?.atRiskCountPercentage,
      },
      timeEntryInfo:
        timeEntryInfo == null
          ? {
              capacityInMinutes: 0,
            }
          : {
              capacityInMinutes: timeEntryInfo.capacity,
              totalTracked: timeEntryInfo.totalTracked,
              totalBillable: timeEntryInfo.totalBillable,
              totalNonBillable: timeEntryInfo.totalNonBillable,
              billableUtilization: timeEntryInfo.billableUtilization,
            },
      allocationInfo:
        allocationInfo == null
          ? {
              minutes: 0,
            }
          : {
              minutes: allocationInfo.minutes,
            },
      timeOffInfo:
        timeOffInfo == null
          ? {
              timeOffMinutes: 0,
            }
          : {
              timeOffMinutes: timeOffInfo.timeOffMinutes,
            },
    }),
  );
};
